export interface IDeviceGroup {
  companyUuid: string;
  createdBy: string;
  description: string;
  deviceGroupStatus: string;
  name: string;
  timeCreated: Date;
  timeUpdated: Date;
  updatedBy: Date;
  id: string;
}
